import { ReconBankUploadPage } from "@/features/recon-bank/pages/ReconBankUploadPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/recon-bank/$id/upload")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["recon_bank.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <ReconBankUploadPage reconID={id} />;
}
